import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { mergeMap } from 'rxjs/internal/operators';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { createEffectFactory } from '@recruitee/ngrx';

import { FeatureFlagsService } from '../feature-flags.service';
import { FeatureFlagEntityActions } from './feature-flags.store';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsEffects implements OnInitEffects {
  public effects = createEffectFactory(FeatureFlagEntityActions, this.actions$);

  public loadFeatureFlagsList$ = this.effects(FeatureFlagEntityActions.fetch, () =>
    this.featureFlagsService.loadFeatureFlags().pipe(filterBoolean),
  );

  public saveFeatureFlagsInLocalStorage$ = this.effects(
    FeatureFlagEntityActions.fetchSuccess,
    ({ payload }) => this.featureFlagsService.saveInLocalStorage(payload),
    { dispatch: false },
  );

  public featureFlagsListInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagEntityActions.init),
      mergeMap(() =>
        this.featureFlagsService
          .loadFeatureFlags()
          .pipe(map(data => FeatureFlagEntityActions.fetchSuccess({ payload: data }))),
      ),
    ),
  );

  constructor(private actions$: Actions, private featureFlagsService: FeatureFlagsService) {}

  public ngrxOnInitEffects(): Action {
    return FeatureFlagEntityActions.init({
      payload: this.featureFlagsService.getFromLocalStorage(),
    });
  }
}
